import script from "./SideNavWithButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SideNavWithButton.vue?vue&type=script&setup=true&lang=js"

import "./SideNavWithButton.vue?vue&type=style&index=0&id=13d2fcbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13d2fcbc"]])

export default __exports__